import { useState } from 'react';

/** Remembers, per room and per browser, which checklist category groups are
 * collapsed — a convenience only: blocked storage just means everything starts
 * open. The admin's and the seller's checklists each use it (they run on their
 * own origins, so each keeps its own choices). */
export function useCollapsedGroups(roomId: string): {
  isCollapsed: (key: string) => boolean;
  toggle: (key: string) => void;
} {
  const storageKey = `closingvault:checklist-collapsed:${roomId}`;
  const [collapsed, setCollapsed] = useState<Set<string>>(() => {
    try {
      const raw = window.localStorage.getItem(storageKey);
      return new Set(raw ? (JSON.parse(raw) as string[]) : []);
    } catch {
      return new Set();
    }
  });
  const toggle = (key: string) =>
    setCollapsed((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      try {
        window.localStorage.setItem(storageKey, JSON.stringify([...next]));
      } catch {
        // Private mode or blocked storage: the choice lasts for this visit only.
      }
      return next;
    });
  return { isCollapsed: (key) => collapsed.has(key), toggle };
}
